export default {"src":"/_next/static/media/footer_linkedin.303c603f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};